import { render, staticRenderFns } from "./addModal.vue?vue&type=template&id=9a11aa68&scoped=true"
import script from "./addModal.vue?vue&type=script&lang=js"
export * from "./addModal.vue?vue&type=script&lang=js"
import style0 from "./addModal.vue?vue&type=style&index=0&id=9a11aa68&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a11aa68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a11aa68')) {
      api.createRecord('9a11aa68', component.options)
    } else {
      api.reload('9a11aa68', component.options)
    }
    module.hot.accept("./addModal.vue?vue&type=template&id=9a11aa68&scoped=true", function () {
      api.rerender('9a11aa68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/localization/langManage/addModal.vue"
export default component.exports